// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Tajikistan from '../_raw/flag/icon_flag_tajikistan.png';

export default () => <img src={Tajikistan} alt="Tajikistan" />;
